import { headers, host } from "./shared";
import axios from "axios";
import type { AxiosResponse } from "axios";

import type { ProfileAuthorisationStatus } from "../../types/api";

export const getProfileAuthorisationStatus = async (
  accessToken?: string | null,
): Promise<AxiosResponse<ProfileAuthorisationStatus>> => {
  return await axios.get(
    `${host}/api/profile_auth_check`,
    headers(accessToken),
  );
};
